<template>
    <div id="contenedor-contrato-cargar-catalogo">
      <!-- Input file anexo -->
      <input
        type="file"
        ref="anexoCatalogo"
        name="anexo"
        id="anexo"
        v-show="false"
        accept=".xlsx"
        @change="leerCatalogo">
      <!-- Mostrar la vista previa del catalogo -->
      <v-card
        v-if="catalogo.length > 0">
        <v-card-title>
          Vista previa
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <!-- Estadistica del anexo leido -->
          <v-row
            no-gutters
            class="grey lighten-3 rounded-lg">
            <v-col
              cols="12"
              md="3">
              <v-card
                flat
                color="transparent">
                <v-card-title>
                  {{ importeContrato | currency }}
                </v-card-title>
                <v-card-text>
                  <template
                    v-if="!contrato.esObraFinanciada">
                    Importe Contratado
                  </template>
                  <template
                    v-else>
                    Costo directo
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="3">
              <v-card
                flat
                color="transparent">
                <v-divider
                  v-if="$vuetify.breakpoint.mobile">
                </v-divider>
                <v-card-title
                  :class="
                    importeDiferenciaCatalogoContrato === 0 ? 'success--text' : 'warning--text'">
                  <template
                    v-if="importeDiferenciaCatalogoContrato === 0">
                    <v-icon
                      class="mr-2"
                      color="success">
                      mdi-checkbox-marked-circle
                    </v-icon>
                  </template>
                  <span>
                    {{ importeDelCatalogo | currency }}
                  </span>
                </v-card-title>
                <v-card-text>
                  <v-alert
                    v-if="importeDiferenciaCatalogoContrato !== 0"
                    type="warning"
                    dense>
                    El importe del catalogo no coincide con el importe del contrato
                  </v-alert>
                  Importe Catálogo
                </v-card-text>
              </v-card>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              cols="12"
              md="3">
              <v-card
                flat
                color="transparent">
                <v-divider
                  v-if="$vuetify.breakpoint.mobile">
                </v-divider>
                <v-card-text>
                  {{ getDatosDelAnexo.name }}
                  <div>
                    {{ new Date(getDatosDelAnexo.lastModified).toLocaleDateString('es-MX') }}
                  </div>
                  <div>
                    {{ $humanFileSize(getDatosDelAnexo.size) }}
                  </div>
                </v-card-text>
                <v-card-actions
                  class="text-center">
                  <v-btn
                    color="success"
                    :disabled="seEstaGuardando || importeDiferenciaCatalogoContrato !== 0"
                    :loading="seEstaGuardando"
                    @click="guardar">
                    <v-icon
                      left>
                      mdi-content-save
                    </v-icon>
                    Guardar
                  </v-btn>
                  <v-btn
                    color="error"
                    @click="cancelarVistaPrevia">
                    <v-icon
                      left>
                      mdi-close-circle
                    </v-icon>
                    Cancelar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <!-- Tabla con los conceptos (Real vista previa) -->
          <vista-previa
            :catalogo="catalogo"
            :importe-contrato="importeContrato">
        </vista-previa>
        </v-card-text>
      </v-card>
    </div>
</template>

<script>
import VistaPrevia from './VistaPrevia.vue';
import CARGAR_CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/mutations/administracion/contratos/contrato/catalogo/cargarContratoCatalogoConceptos.gql';

const baseURL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3203/leer/catalogo'
  : 'https://sideop-excel.hermosillo.gob.mx/leer/catalogo';

export default {
  name: 'ContratoCargarCatalogo',
  components: {
    VistaPrevia,
  },
  props: {
    cargar: {
      type: Boolean,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      uploadProgress: 0,
      seEstaGuardando: false,
      idObra: '',
      idConvenio: '',
      catalogo: [],
    };
  },
  methods: {
    seleccionarCatalogo() {
      this.$refs.anexoCatalogo.click();
    },
    cancelarVistaPrevia() {
      this.catalogo = [];
      this.$emit('seCargoVistaPreviaCatalogo', false);
    },
    async leerCatalogo() {
      this.mixEsCargando();
      const esto = this;
      const dataForm = new FormData();
      dataForm.append('anexo', document.getElementById('anexo').files[0]);

      await this.axios.post(
        baseURL,
        dataForm,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress(progressEvent) {
            if (progressEvent.lengthComputable) {
              esto.uploadProgress = Math.round((progressEvent.loaded * 100)
            / progressEvent.total);
            }
          },
        },
      )
        .then(({ data }) => {
          this.catalogo = data;
          this.$emit('seCargoVistaPreviaCatalogo', true);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });

      esto.uploadProgress = 0;
      this.mixEsCargando();
    },
    async guardar() {
      this.mixEsCargando();
      this.seEstaGuardando = true;

      await this.$apollo
        .mutate({
          mutation: CARGAR_CONTRATO_CATALOGO_CONCEPTOS,
          variables: {
            catalogo: this.prepararCatalogoParaGuardar,
          },
        })
        .then(() => {
          this.catalogo = [];
          this.mixMensajeSuccess();
          this.$emit('seGuardoCatalogo');
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.seEstaGuardando = false;
      this.mixEsCargando();
    },
  },
  computed: {
    getDatosDelAnexo() {
      const anexo = document.getElementById('anexo').files[0];
      if (!anexo) return null;
      return anexo;
    },
    importeContrato() {
      if (this.contrato.esObraFinanciada) {
        return this.contrato.importeCostoDirecto;
      }
      return this.contrato.importe;
    },
    importeDelCatalogo() {
      return this.$ObjSumar(this.catalogo, 'importe') || 0;
    },
    importeDiferenciaCatalogoContrato() {
      return this.importeContrato - this.importeDelCatalogo;
    },
    cantidadRegistros() {
      return this.catalogo.length;
    },
    cantidadPartidas() {
      return this.catalogo.filter((concepto) => concepto.tipo === 0).length;
    },
    cantidadSubPartidas() {
      return this.catalogo.filter((concepto) => concepto.tipo === 1).length;
    },
    cantidadConceptos() {
      return this.catalogo.filter((concepto) => concepto.tipo === 2).length;
    },
    prepararCatalogoParaGuardar() {
      const { catalogo } = this;
      return catalogo.map((concepto) => ({
        idContrato: this.contrato.id,
        ...concepto,
      }));
    },
  },
  watch: {
    cargar: {
      handler() {
        this.seleccionarCatalogo();
      },
    },
  },
};
</script>

<style lang="scss">

</style>
